var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.DragFunctionality = new Class({
    Implements: [Options, Events],
    options: {
        active_class: "active",
        cancel_event: "cancel",
        complete_event: "complete",
        drag_handle: "",
        drag_start_timeout: 300,
        drop_container_id: 'drop_panel_container',
        droppable_class_selector: "#drop_panel_container .panel",
        dropped_event: 'dropped',
        element_drag_inprogress_class: "dragging",
        start_event: 'start'
    },
    drag_start_event: null,
    drag_start_timeout: null,
    droppables: [],
    bound_methods: {},
    element: null,
    clone: null,
    initialize: function (element, ops) {
        if (ops) {
            this.setOptions(ops);
        }
        this.bound_methods.on_draggable_mousedown = this.on_draggable_mousedown.bind(this);
        this.bound_methods.on_draggable_mouseup = this.on_draggable_mouseup.bind(this);
        this.bound_methods.on_draggable_cancel = this.on_draggable_cancel.bind(this);
        this.bound_methods.on_draggable_complete = this.on_draggable_complete.bind(this);
        this.bound_methods.on_draggable_drop = this.on_draggable_drop.bind(this);
        this.bound_methods.on_draggable_enter = this.on_draggable_enter.bind(this);
        this.bound_methods.on_draggable_leave = this.on_draggable_leave.bind(this);
        if (element) {
            var obj = element.retrieve('draggable');
            if (obj) {
                return obj;
            }

            this.element = element;
            if (this.options.drag_handle !== "") {
                element.getElements(this.options.drag_handle).each(function (handle) {
                    handle.addEvent('mousedown', this.bound_methods.on_draggable_mousedown);
                    handle.addEvent('mouseup', this.bound_methods.on_draggable_mouseup);
                }, this);
            } else {
                element.addEvent('mousedown', this.bound_methods.on_draggable_mousedown);
                element.addEvent('mouseup', this.bound_methods.on_draggable_mouseup);
            }
            element.store('draggable', this);
        }

    },
    init_droppable: function () {
        var layout = document.id('panel_container').getProperty('class');
        var template_name = 'drop_' + layout;
        var tm = OCS.WxBriefing.Functions.get_template_manager();
        if (!tm.get_html(template_name)) {
            tm.define_template(template_name, document.id(template_name).get('html'));
        }
        this.destroy_droppable();
        document.id(this.options.drop_container_id).addClass(layout).addClass(this.options.active_class).set('html', tm.get_html(template_name, {}));
        this.droppables = $$(this.options.droppable_class_selector);
        return this;
    },
    destroy_droppable: function () {
        var drop_container = document.id(this.options.drop_container_id);
        if (drop_container) {
            drop_container.empty().removeClass(this.options.active_class).removeClass(drop_container.getProperty('class'));
            drop_container.removeEvents();
        }
        this.droppables = [];
    },
    on_drag_start_timeout: function () {
        if (this.drag_start_timeout) {
            clearTimeout(this.drag_start_timeout);
            this.drag_start_timeout = null;
        }
        if (this.drag_start_event) {
            // Lets give this a place to drop into
            this.init_droppable();
            this.clone = this.element.clone().addClass(this.options.element_drag_inprogress_class).setStyles(this.element.getCoordinates());
            this.clone.inject(document.body);
            var drag = this.clone.makeDraggable({
                precalculate: true,
                droppables: this.droppables,
                onComplete: this.bound_methods.on_draggable_complete,
                onDrop: this.bound_methods.on_draggable_drop,
                onEnter: this.bound_methods.on_draggable_enter,
                onLeave: this.bound_methods.on_draggable_leave,
                onCancel: this.bound_methods.on_draggable_cancel
            }); // this returns the dragged element
            this.fireEvent(this.options.start_event, [this.element, this.drag_start_event, this]);
            drag.start(this.drag_start_event); // start the event manual
            this.drag_start_event = null;
        }
    },
    on_draggable_cancel: function (element, event) {
        if (this.clone) {
            this.clone.destroy();
        }
        this.destroy_droppable();
        if (event) {
            this.fireEvent(this.options.cancel_event, [this.element, event, this]);
        }
    },
    on_draggable_complete: function (element, event) {
        this.on_draggable_cancel();
        this.fireEvent(this.options.complete_event, [this.element, event, this]);
    },
    on_draggable_drop: function (element, droppable, event) {
        if (droppable) {
            droppable.removeClass('active');
            this.fireEvent(this.options.dropped_event, [this.element, droppable, event, this]);
        }
    },
    on_draggable_enter: function (element, droppable) {
        if (droppable) {
            droppable.addClass('active');
        }
    },
    on_draggable_mousedown: function (event) {
        if (this.drag_start_timeout) {
            clearTimeout(this.drag_start_timeout);
            this.drag_start_timeout = null;
        }
        this.drag_start_event = event;
        if (this.options.drag_start_timeout) {
            this.drag_start_timeout = setTimeout(this.on_drag_start_timeout.bind(this), this.options.drag_start_timeout);
        } else {
            this.on_drag_start_timeout();
        }
    },
    on_draggable_mouseup: function (event) {
        if (this.drag_start_timeout) {
            clearTimeout(this.drag_start_timeout);
            this.drag_start_timeout = null;
        }
        this.drag_start_event = null;
    },
    on_draggable_leave: function (element, droppable) {
        if (droppable) {
            droppable.removeClass('active');
        }
    },
    destroy: function () {
        if (this.drag_start_timeout) {
            clearTimeout(this.drag_start_timeout);
            this.drag_start_timeout = null;
        }
        if (this.clone) {
            this.clone.destroy();
            this.clone = null;
        }        
        if (this.element) {
            this.element.store('draggable', null);
            if (this.options.drag_handle !== "") {
                this.element.getElements(this.options.drag_handle).each(function (handle) {
                    handle.removeEvent('mousedown', this.bound_methods.on_draggable_mousedown);
                    handle.removeEvent('mouseup', this.bound_methods.on_draggable_mouseup);
                }, this);
            } else {
                this.element.removeEvent('mousedown', this.bound_methods.on_draggable_mousedown);
                this.element.removeEvent('mouseup', this.bound_methods.on_draggable_mouseup);
            }
            this.element = null;
        }
    }
});
